import React, {Component} from 'react';
import '../../styles/Home.css'
import DatePicker from 'react-datepicker'
import {Button} from "react-bootstrap";
import axios from "axios";
import AppConfig from "../../AppConfig";
import moment from "moment";
import Zgody from "../../shared/Zgody";
import {NotificationManager} from "react-notifications";
import Mapa from "./Mapa";
import Footer from "../../shared/Footer";
import WynajemGaleria from "./wynajemComponents/WynajemGaleria";

let URL = AppConfig.HOST_API();

export default class Wynajem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            miejsceOd: '',
            miejsceDo: '',
            dataOd: moment().add(1, 'days'),
            dataDo: moment().add(2, 'days'),
            godzinaOd: '00:00',
            godzinaDo: '23:59',
            liczbaPasazerow: '',
            nazwa: '',
            telefon: '',
            email: '',
            uwagi: '',
            miejsceOdInvalid: false,
            miejsceDoInvalid: false,
            liczbaPasazerowInvalid: false,
            nazwaInvalid: false,
            telefonInvalid: false,
            emailInvalid: false,
            success: false,
            warunki: false,
            buttonLoader: false
        };

        this.handleMiejsceOd = this.handleMiejsceOd.bind(this);
        this.handleMiejsceDo = this.handleMiejsceDo.bind(this);
        this.handleDataOd = this.handleDataOd.bind(this);
        this.handleDataDo = this.handleDataDo.bind(this);
        this.handleGodzinaOd = this.handleGodzinaOd.bind(this);
        this.handleGodzinaDo = this.handleGodzinaDo.bind(this);
        this.handleLiczbaPasazerow = this.handleLiczbaPasazerow.bind(this);
        this.handleNazwa = this.handleNazwa.bind(this);
        this.handleTelefon = this.handleTelefon.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleUwagi = this.handleUwagi.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (this.props.success === true) {
            this.setState({success: true})
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.state.success !== nextProps.success) {
            this.setState({success: false})
        }
    }

    handlePost() {
        let miejsceOd, miejsceDo, godzinaOd, godzinaDo, liczbaPasazerow, nazwa, telefon, email = false;
        let phoneCheck = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

        if (this.state.miejsceOd.length < 3) {
            miejsceOd = true
        }
        if (this.state.miejsceDo.length < 3) {
            miejsceDo = true
        }
        if (this.state.liczbaPasazerow < 1 || !Number.isInteger(parseFloat(this.state.liczbaPasazerow)) || this.state.liczbaPasazerow > 999) {
            liczbaPasazerow = true
        }
        if (this.state.nazwa.length < 3) {
            nazwa = true
        }
        if (!phoneCheck.test(this.state.telefon) && this.state.telefon.length !== 9) {
            telefon = true
        }
        if (!this.state.email.match(/\S+@\S+\.\S+/)) {
            email = true
        }
        if (this.state.godzinaOd.length === 0) {
            godzinaOd = true
        }
        if (this.state.godzinaDo.length === 0) {
            godzinaDo = true
        }

        let dataOd = moment(this.state.dataOd).toISOString().substr(0, 10) + 'T' + this.state.godzinaOd + ':00';
        let dataDo = moment(this.state.dataDo).toISOString().substr(0, 10) + 'T' + this.state.godzinaDo + ':00';

        if (!miejsceOd && !miejsceDo && !godzinaOd && !godzinaDo && !liczbaPasazerow && !nazwa && !telefon && !email) {
            if (this.state.warunki) {
                this.setState({buttonLoader: true})
                return axios({
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    url: URL + 'client/api/wynajem' + AppConfig.V_LOG(),
                    data: {
                        "dataDo": dataDo,
                        "dataOd": dataOd,
                        "ileOsob": this.state.liczbaPasazerow,
                        "klientEmail": this.state.email,
                        "klientNazwa": this.state.nazwa,
                        "klientTelefon": this.state.telefon,
                        "klientUwagi": this.state.uwagi,
                        "miejsceDo": this.state.miejsceDo,
                        "miejsceOd": this.state.miejsceOd
                    }
                }).then((response) => {
                    this.setState({success: true, buttonLoader: false})
                }).catch((e) => {
                    console.log(e)
                    this.setState({buttonLoader: false})
                })
            } else {
                NotificationManager.error("", "Aby dokonać zapytania ofertowego należy akceptować warunki ", 5000);

            }
        } else {
            NotificationManager.error("", "Uzupełnij wymagane pola ", 5000);
            this.setState({
                miejsceOdInvalid: miejsceOd,
                miejsceDoInvalid: miejsceDo,
                liczbaPasazerowInvalid: liczbaPasazerow,
                nazwaInvalid: nazwa,
                telefonInvalid: telefon,
                emailInvalid: email,
                godzinaOdInvalid: godzinaOd,
                godzinaDoInvalid: godzinaDo
            })
        }
    }

    handleMiejsceOd(e) {
        if (e.target.value.length > 3) {
            this.setState({miejsceOd: e.target.value, miejsceOdInvalid: false})
        } else {
            this.setState({miejsceOd: e.target.value})
        }

    }

    handleMiejsceDo(e) {
        if (e.target.value.length > 3) {
            this.setState({miejsceDo: e.target.value, miejsceDoInvalid: false})
        } else {
            this.setState({miejsceDo: e.target.value})
        }
    }

    handleDataOd(e) {
        if (moment(e) < moment().add(-1, "days")) {
            this.setState({dataOd: moment()});
            NotificationManager.error("", "Nie można użyć daty wstecznej ", 5000);

        } else {
            if (moment(e).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') && this.state.godzinaOd < moment().format('HH:mm')) {
                this.setState({dataOd: e, godzinaOd: moment().format('HH:mm')});
            } else {
                if (this.state.dataDo !== '') {
                    if (moment(e) > moment(this.state.dataDo)) {
                        this.setState({dataDo: e, dataOd: e})
                    } else {
                        this.setState({dataOd: e})
                    }
                } else {
                    this.setState({dataOd: e})
                }
            }
        }
    }

    handleDataDo(e) {
        if (this.state.dataOd === '') {
            NotificationManager.error("", "Najpierw wybierz datę wyjazdu ", 5000);

        } else {
            if (moment(e).format('YYYY-MM-DD') < moment(this.state.dataOd).format('YYYY-MM-DD')) {
                NotificationManager.error("", "Data powrotu nie może być wcześniejsza od daty wyjazdu ", 5000);

            } else {
                if (moment(e).format('YYYY-MM-DD') === moment(this.state.dataOd).format('YYYY-MM-DD') && this.state.godzinaDo < this.state.godzinaOd) {
                    this.setState({dataDo: e, godzinaDo: this.state.godzinaOd})
                } else {
                    if (moment(e).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')  && this.state.godzinaDo < moment()) {
                        this.setState({dataDo: e, godzinaDo: this.state.godzinaOd})
                    } else {
                        this.setState({dataDo: e})
                    }
                }
            }
        }
    }

    handleGodzinaOd(e) {
        if (this.state.dataOd === '' || this.state.dataDo === '') {
            NotificationManager.error("", "Najpierw wybierz datę ", 5000);
        } else {
            if (this.state.dataOd.dayOfYear() === this.state.dataDo.dayOfYear() && e.target.value > this.state.godzinaDo) {
                this.setState({godzinaOd: e.target.value, godzinaDo: e.target.value})
            } else {
                this.setState({godzinaOd: e.target.value})
            }
        }
    }

    handleGodzinaDo(e) {
        if (this.state.dataOd === '' || this.state.dataDo === '') {
            NotificationManager.error("", "Najpierw wybierz datę ", 5000);
        } else {
            if (this.state.dataOd.dayOfYear() === this.state.dataDo.dayOfYear()) {
                if (e.target.value < this.state.godzinaOd) {
                    this.setState({godzinaDo: this.state.godzinaOd})
                } else {
                    this.setState({godzinaDo: e.target.value})
                }
            } else {
                this.setState({godzinaDo: e.target.value})
            }
        }
    }

    handleLiczbaPasazerow(e) {
        if (e.target.value > 0 || e.target.value <= 999) {
            this.setState({liczbaPasazerow: e.target.value, liczbaPasazerowInvalid: false})
        } else {
            this.setState({liczbaPasazerow: e.target.value})
        }
    }

    handleNazwa(e) {
        if (e.target.value.length > 3) {
            this.setState({nazwa: e.target.value, nazwaInvalid: false})
        } else {
            this.setState({nazwa: e.target.value})
        }
    }

    handleTelefon(e) {
        if (e.target.value.length === 9) {
            this.setState({telefon: e.target.value, telefonInvalid: false})
        } else {
            this.setState({telefon: e.target.value})
        }
    }

    handleEmail(e) {
        if (e.target.value.match(/\S+@\S+\.\S+/)) {
            this.setState({email: e.target.value, emailInvalid: false})
        } else {
            this.setState({email: e.target.value})
        }
    }

    handleUwagi(e) {
        this.setState({uwagi: e.target.value})
    }

    render() {
        return <div>

            <div className="wynajemNaglowek przerywnik">
                <div className="container text-center">
                    <h2><b>Oferujemy wynajem pojazdów wraz z kierowcą dla potrzeb klienta.</b></h2>
                    <h4>Aby złożyć zamówienie należy wypełnić poniższy formularz.</h4>
                </div>
            </div>
            <div className="panelPaddingMobilka"
                 style={{backgroundColor: '#f9f9f9', paddingTop: 20, paddingBottom: 15}}>
                <div className="container paddingContainerMobilka" style={{paddingLeft: 0, paddingRight: 0}}>

                    <div className="wynik ramka formularzWynajmu"
                         style={{paddingTop: 50, paddingBottom: 50, marginTop: 0}}>

                        {this.state.success ?
                            <div className="text-center" style={{padding: 50}}>
                                <b><h2><i className="fa fa-2x fa-check" style={{color: '#8dc846'}}> </i> Twoje zapytanie
                                    o wynajem przebiegło pomyślnie</h2>
                                    <h5 style={{fontWeight: 400}}>Nasz konsultant skontaktuje się na podane dane
                                        kontaktowe.</h5></b>
                            </div>
                            :
                            <div>
                                <div className="row" style={{alignItems: 'center', width: '90%', margin: '0 auto'}}>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 text-center">
                                                <h2 className="text-center" style={{fontWeight: 'bold'}}>Zapytanie
                                                    ofertowe</h2>
                                            </div>
                                            <div style={{alignItems: 'center', width: '97%', margin: '0 auto'}}>
                                                <hr/>
                                                <WynajemGaleria/>
                                            </div>
                                            <div className="col-12">
                                                <hr/>
                                                <p style={{fontWeight: 'normal'}}>Jeśli tylko macie Państwo potrzebę
                                                    poznania naszej oferty w zakresie warunków
                                                    organizacyjnych i finansowych, uprzejmi eprosimy o przesłanie
                                                    zapytania
                                                    ofertowego korzystając z poniższego formularza. Postaramy się
                                                    odpowiedzieć
                                                    najpóźniej w ciągu jednego dnia roboczego. Prosimy o możliwie
                                                    precyzyjne
                                                    określenie Państwa oczekiwań uwzględniając datę, godziny, trasę oraz
                                                    ilość
                                                    osób jak i deklarując rodzaj pojazdu.</p>
                                                <hr/>
                                            </div>
                                            <div className="col-12" style={{paddingBottom: '15px'}}>
                                                <b className="daneNaglowek">Dane wynajmu:</b>
                                            </div>
                                            <div className="col-6">
                                                Miejsce od<font color="red">*</font>:
                                                <input type="text" className="form-control" value={this.state.miejsceOd}
                                                       onChange={this.handleMiejsceOd}/>
                                                {this.state.miejsceOdInvalid ?
                                                    <div className="niepoprawneDaneWynajem">Niepoprawne miejsce
                                                        wyjazdu.</div> : null}
                                            </div>
                                            <div className="col-6">
                                                Miejsce do<font color="red">*</font>:
                                                <input type="text" className="form-control" value={this.state.miejsceDo}
                                                       onChange={this.handleMiejsceDo}/>
                                                {this.state.miejsceDoInvalid ?
                                                    <div className="niepoprawneDaneWynajem">Niepoprawne miejsce
                                                        powrotu.</div> : null}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-3 dataMobilkaWynajem">
                                                Data od<font color="red">*</font>:
                                                <DatePicker dateFormat="YYYY-MM-DD"
                                                            selected={this.state.dataOd}
                                                            locale="pl"
                                                            readOnly={true}
                                                            className="form-control"
                                                            onChange={this.handleDataOd}
                                                            placeholderText={moment().format("YYYY-MM-DD")}/>
                                            </div>
                                            <div className="col-3 dataMobilkaWynajem">
                                                Data do<font color="red">*</font>:
                                                <DatePicker
                                                    dateFormat="YYYY-MM-DD"
                                                    selected={this.state.dataDo}
                                                    locale="pl"
                                                    readOnly={true}
                                                    className="form-control"
                                                    onChange={this.handleDataDo}
                                                    placeholderText={moment().add(1, 'days').format("YYYY-MM-DD")}/>
                                            </div>
                                            <div className="col-6">
                                                Liczba pasażerów<font color="red">*</font>:
                                                <input type="number" className="form-control"
                                                       min={1}
                                                       maxLength={3}
                                                       step={1}
                                                       value={this.state.liczbaPasazerow}
                                                       onChange={this.handleLiczbaPasazerow}/>
                                                {this.state.liczbaPasazerowInvalid ?
                                                    <div className="niepoprawneDaneWynajem">Niepoprawna liczba
                                                        pasażerów.</div> : null}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-3 dataMobilkaWynajem">
                                                Godzina od<font color="red">*</font>:
                                                <input type="time" className={'form-control'} style={{width: '82%'}}
                                                       value={this.state.godzinaOd}
                                                       onChange={this.handleGodzinaOd}/>
                                                {this.state.godzinaOdInvalid ?
                                                    <div className="niepoprawneDaneWynajem">Niepoprawna godzina
                                                        wyjazdu.</div> : null}
                                            </div>
                                            <div className="col-3 dataMobilkaWynajem">
                                                Godzina do<font color="red">*</font>:
                                                <input type="time" className={'form-control'} style={{width: '82%'}}
                                                       value={this.state.godzinaDo}
                                                       onChange={this.handleGodzinaDo}
                                                       placeholder={'23:59'}/>
                                                {this.state.godzinaDoInvalid ?
                                                    <div className="niepoprawneDaneWynajem">Niepoprawna godzina
                                                        powrotu.</div> : null}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12"
                                                 style={{
                                                     fontSize: '0.875rem',
                                                     paddingTop: '10px',
                                                     paddingBottom: '15px'
                                                 }}>
                                                <hr/>
                                                <b className="daneNaglowek">Dane klienta:</b>
                                            </div>
                                            <div className="col-12">
                                                Imię i nazwisko / Nazwa firmy<font color="red">*</font>:
                                                <input type="text" className="form-control" value={this.state.nazwa}
                                                       onChange={this.handleNazwa}/>
                                                {this.state.nazwaInvalid ?
                                                    <div className="niepoprawneDaneWynajem">Niepoprawne dane
                                                        klienta.</div> : null}
                                            </div>
                                            <div className="col-6">
                                                Numer telefonu<font color="red">*</font>:
                                                <input type="text" className="form-control" value={this.state.telefon}
                                                       onChange={this.handleTelefon}/>
                                                {this.state.telefonInvalid ?
                                                    <div className="niepoprawneDaneWynajem">Niepoprawny numer
                                                        telefonu.</div> : null}
                                            </div>
                                            <div className="col-6">
                                                E-mail<font color="red">*</font>:
                                                <input type="text" className="form-control" value={this.state.email}
                                                       onChange={this.handleEmail}/>
                                                {this.state.emailInvalid ?
                                                    <div className="niepoprawneDaneWynajem">Niepoprawny adres
                                                        e-mail.</div> : null}
                                            </div>
                                            <div className="col-12">
                                                Uwagi:
                                                <textarea rows="3" className="form-control" maxLength={999}
                                                          value={this.state.uwagi}
                                                          onChange={this.handleUwagi}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row" style={{paddingTop: '15px'}}>
                                        <div className="col-12 text-center">
                                            <Zgody war2={true} warunki={this.state.warunki}
                                                   setWarunki={() => this.setState({warunki: !this.state.warunki})}/>
                                        </div>
                                        <div className="col-12 text-right">
                                            <Button bsStyle='success' disabled={this.state.buttonLoader}
                                                    onClick={() => {
                                                        this.handlePost()
                                                    }}>Wyślij</Button>
                                            {this.state.buttonLoader ?
                                                <div className="loaderDim" style={{marginTop: 5}}><i
                                                    className="fa fa-spinner fa-pulse fa-fw"
                                                    style={{
                                                        color: '#58b13d'
                                                    }}> </i></div> : null}
                                        </div>
                                    </div>
                                </div>
                            </div>}

                    </div>
                </div>
            </div>
            <Mapa/>
            <Footer/>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/Wynajem.js